import React from "react";

const LazyDoughnut = React.lazy(() =>
  import('react-chartjs-2').then(mod => ({ default: mod.Doughnut }))
);
export default LazyDoughnut;
